import { render, staticRenderFns } from "./QueueForm.vue?vue&type=template&id=0fc32d04&scoped=true&"
import script from "./QueueForm.vue?vue&type=script&lang=ts&"
export * from "./QueueForm.vue?vue&type=script&lang=ts&"
import style0 from "./QueueForm.vue?vue&type=style&index=0&id=0fc32d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc32d04",
  null
  
)

export default component.exports